
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class CallCard extends Vue {
  @Prop({ required: true })readonly scheduleTo: Date
  @Prop({ required: true })readonly start: Date
  @Prop({ required: true })readonly id: number
  @Prop({ required: true })readonly end: Date
  @Prop({ required: true })readonly urlLink: string
  @Prop({ required: true })readonly processed: boolean
  @Prop({ required: true })readonly processedComplete: number
  @Prop({ required: true })readonly users: Array
  data () {
    return {
    }
  }

  get displayGoToBtn () {
    var now = new Date()
    var onehourAgo = new Date(now.valueOf() - 60 * 60 * 1000)
    return this.scheduleTo > onehourAgo
  }

  get displayReadTranscription () {
    return this.processedComplete > -1
  }

  goToCall () {
    if (this.processed) {
      window.location.href = `/home/callTranscript/${this.id}`
    } else {
      window.location.href = `/home/call/${this.id}`
    }
  }

  goToTranscription () {
    window.location.href = `/home/callTranscript/${this.id}`
  }
}
